































































import {
  AisConfigure,
  AisStateResults,
} from 'vue-instantsearch';

import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';
import FilterModal from '~/components/organisms/Search/FilterModal.vue';
import SearchResultsTop from '~/components/organisms/Search/SearchResultsTop/SearchResultsTop.vue';
import SearchResultsInner from '~/components/organisms/Search/SearchResultsInner.vue';
import type { ProductGroupsItemType } from '~/types/cms/ProductGroupsItem';
import { useAlgolia } from '~/composables';
import { HITS_PER_PAGE_ITEMS, ALGOLIA_ATTRIBUTE, MAX_STARS } from '~/constants/algolia';
import { getAlgoliaSortingConfiguration } from '~/helpers/algolia/getAlgoliaSortingConfiguration';
import { getCurrentInstance } from '~/helpers/getCurrentInstance';
import VirtualSortBy from '~/components/molecules/Search/Virtual/VirtualSortBy.vue';
import VirtualRangeInput from '~/components/molecules/Search/Virtual/VirtualRangeInput.vue';
import VirtualRatingMenu from '~/components/molecules/Search/Virtual/VirtualRatingMenu.vue';
import VirtualPagination from '~/components/molecules/Search/Virtual/VirtualPagination.vue';

export default defineComponent({
  name: 'SearchResults',
  components: {
    FilterModal,
    AisConfigure,
    AisStateResults,
    VirtualSortBy,
    VirtualRangeInput,
    VirtualRatingMenu,
    VirtualPagination,
    SearchResultsTop,
    SearchResultsInner,
  },
  props: {
    categoryFilter: {
      type: String,
      default: '',
    },
    enableStateMapping: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    productGroupItems: {
      type: Array as PropType<Array<ProductGroupsItemType>>,
      default: () => [],
    },
    productGroupItemsTextColor: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    productGroupItemsBackgroundColor: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
  setup() {
    const root = getCurrentInstance();
    const { $i18n } = root;

    const { hitsPerPageConfiguration } = useAlgolia();
    HITS_PER_PAGE_ITEMS.forEach(config => {
      config.default = config.value === hitsPerPageConfiguration.value;
    });

    return {
      sortingConfig: getAlgoliaSortingConfiguration($i18n),
      hitsPerPageConfiguration,
      ALGOLIA_ATTRIBUTE,
      MAX_STARS,
    };
  },
});
